import classNames from 'classnames';
import { Heading } from 'yoso';
import { Adventure, useAdventure } from '~/components/Adventure/Adventure.hooks';
import { AdventureStatusBarDescriptionList } from '~/components/Adventure/Status/DescriptionList/AdventureStatusBarDescriptionList';
import { T } from '~/components/I18n/Translation';
import { StatusBarAccordion } from '~/components/Status/Bar/Accordion/StatusBarAccordion';
import { StatusBarProfile } from '~/components/Status/Bar/Profile/StatusBarProfile';
import statusBarStyles from '~/components/Status/Bar/StatusBar.module.scss';
import myItemsStyles from '~/components/Status/Bar/StatusBarMyItems.module.scss';
import styles from './AdventureStatusBar.module.scss';

export type AdventureStatusBarProps = {
  id: Adventure['id'];
  className?: string;
};

export const AdventureStatusBar = ({ className, id }: AdventureStatusBarProps) => {
  const { data: { participation } = {} } = useAdventure(id);
  const { currentCount, maxCount } = participation || {};

  return (
    <div className={classNames(statusBarStyles.root, className)}>
      <StatusBarProfile className={statusBarStyles.header}>
        <T name="citizen_adventure_myweeklyjoin_others" options={[id, currentCount]} />
        <span className={styles.trial}>
          {' '}
          / <T name="citizen_adventure_myweeklyjoin_trial" options={[maxCount]} />
        </span>
      </StatusBarProfile>
      <div className={statusBarStyles.body}>
        <StatusBarAccordion>
          <Heading level={5} className={myItemsStyles.title}>
            <T name="citizen_land_menu_myhistory_asset_desc" />
          </Heading>
          <AdventureStatusBarDescriptionList />
        </StatusBarAccordion>
      </div>
    </div>
  );
};
